import React from "react";
import { Container } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import { Col } from "react-bootstrap";

function Refund() {
  return (
    <>
      <Container fluid>
        <Row className="headingimg">
          <Col className="m-5">
            <h1 className="text-white m-4 mx-4 px-2 fw-bold text-center">
              Refund Policy
            </h1>
            <div className="text-white m-4 fw-bold text-center">
              <a href="/" className=" text-white m-3 text-decoration-none">
                Home
              </a>
              <i class="fa-solid fa-circle-arrow-right fa-beat"></i>
              <a className="text-white text-decoration-none m-3">
                Refund Policy
              </a>
            </div>
          </Col>
        </Row>
        <Row>
          <Col className="text-muted m-5">
            <p> Royal Green Energy’s refund policy is valid for 7 days</p>
            <p>
              from the date of purchase; after this period, no refunds or
              exchanges will be provided. If a refund is initiated,
            </p>
            <p>
              access to any related Royal Green Energy services (if applicable)
              will be discontinued, and in case of subscriptions,{" "}
            </p>
            <p>
              the service will continue only until the end of the current
              billing cycle with no partial refunds.
            </p>
            <p>
              Refunds will be processed only for the actual amount paid after
              applying any coupons or discounts,
            </p>{" "}
            <p> and payment gateway or transaction charges will be deducted.</p>
            <p>
              Royal Green Energy does not control the time taken by banks or
              payment gateways to complete refunds.
            </p>
            <p>
              Billing and transaction records are retained for up to one year
              for accounting purposes, and customized or
            </p>{" "}
            <p>
              {" "}
              made-to-order electrical infrastructure materials are not eligible
              for refund unless agreed in writing.
            </p>
            <p>For any queries, contact support@royalgreenenergy.com .</p>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Refund;
